var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "thailand-info" },
    [
      _c("div", { staticStyle: { width: "fit-content" } }, [
        _c(
          "div",
          { staticStyle: { display: "flex" } },
          [
            _c("thailand-address-format-form", {
              attrs: {
                job: _vm.job,
                readonly: _vm.readonly,
                "address-form": _vm.afrAddress
              },
              on: {
                showSenderAndReceiverDialog: _vm.showSenderAndReceiverDialog
              }
            }),
            _c(
              "div",
              { staticClass: "section form-column" },
              [
                _c(
                  "el-form",
                  {
                    staticStyle: { height: "100%" },
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "112px",
                      "label-position": "right"
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "title",
                        attrs: { title: _vm.$t("SeaExport.CargoInformation") }
                      },
                      [_vm._v(_vm._s(_vm.getItemTitle("Cargo Information")))]
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.getItemTitle("HB/L NO"),
                          title: _vm.$t("SeaExport.HBLNumber")
                        }
                      },
                      [
                        _c("el-input", {
                          on: { input: _vm.hblNbr2Change },
                          model: {
                            value: _vm.form.hblNbr2,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "hblNbr2", $$v)
                            },
                            expression: "form.hblNbr2"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          title: _vm.$t("SeaExport.BillOfLadingQuantity"),
                          label: _vm.getItemTitle("Quantity")
                        }
                      },
                      [
                        _c("auto-number-input", {
                          attrs: { precision: 0, min: 0 },
                          model: {
                            value: _vm.form.quantity,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "quantity", $$v)
                            },
                            expression: "form.quantity"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          title: _vm.$t("SeaExport.Packing"),
                          label: "Unit Type"
                        }
                      },
                      [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: _vm.$t(
                                    "CargoMsg.Cargo_AmsUnitTypeTip"
                                  ),
                                  placement: "right-end"
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-question",
                                  staticStyle: {
                                    cursor: "pointer",
                                    color: "#1F75D5"
                                  }
                                })
                              ]
                            ),
                            _vm._v(
                              " " + _vm._s(_vm.getItemTitle("Unit Type")) + " "
                            )
                          ],
                          1
                        ),
                        _c("cargo-packing-select", {
                          staticStyle: { width: "100%" },
                          attrs: { "default-value": _vm.form.packing },
                          on: { change: _vm.changeUnitType }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          title: _vm.$t("SeaExport.GrossWeight"),
                          label: _vm.getItemTitle("Gross Weight")
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-input-number", {
                              staticStyle: { flex: "1" },
                              attrs: { precision: 3, controls: false },
                              model: {
                                value: _vm.form.weight,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "weight", $$v)
                                },
                                expression: "form.weight"
                              }
                            }),
                            _c("span", [_vm._v("KGS")])
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          title: _vm.$t("SeaExport.Cubage"),
                          label: _vm.getItemTitle("Volume")
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-input-number", {
                              staticStyle: { flex: "1" },
                              attrs: { precision: 3, controls: false },
                              model: {
                                value: _vm.form.cubage,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "cubage", $$v)
                                },
                                expression: "form.cubage"
                              }
                            }),
                            _c("span", [_vm._v("CBM")])
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          title: "Container Status",
                          label: "Container Status"
                        }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { clearable: false },
                            on: { change: _vm.changeContainerStatus },
                            model: {
                              value: _vm.form.containerStatus,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "containerStatus", $$v)
                              },
                              expression: "form.containerStatus"
                            }
                          },
                          [
                            _c("el-option", {
                              attrs: { value: "4", label: "4.MTY (Empty)" }
                            }),
                            _c("el-option", {
                              attrs: {
                                value: "7",
                                label: "7.LCL (Less Container Load)"
                              }
                            }),
                            _c("el-option", {
                              attrs: {
                                value: "8",
                                label: "8.FCL (Full Container Load)"
                              }
                            }),
                            _c("el-option", {
                              attrs: {
                                value: "9",
                                label: "9.CFS (Container Freight Station)"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.getItemTitle("Place of Receipt"),
                          title: _vm.$t("SeaExport.BillLadingPlaceOfDispatch")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          staticStyle: { flex: "1" },
                          attrs: {
                            "select-type": _vm.TYPE_NAMES.basic_data_Seaport,
                            filterable: "",
                            "default-value": _vm.form.dispatchingPlaceCode,
                            "tag-name": "englishName"
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.portChange(
                                p,
                                "dispatchingPlaceCode",
                                "dispatchingPlace"
                              )
                            }
                          }
                        }),
                        _c("el-input", {
                          attrs: { disabled: "" },
                          model: {
                            value: _vm.form.dispatchingPlace,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "dispatchingPlace", $$v)
                            },
                            expression: "form.dispatchingPlace"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.getItemTitle("Place of Delivery"),
                          title: _vm.$t("SeaExport.BillLadingPlaceOfDelivery")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            "select-type": _vm.TYPE_NAMES.basic_data_Seaport,
                            filterable: "",
                            "default-value": _vm.form.destinationPortCode || "",
                            "tag-name": "englishName"
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.portChange(
                                p,
                                "destinationPortCode",
                                "destinationPort"
                              )
                            }
                          }
                        }),
                        _c("el-input", {
                          attrs: { disabled: "" },
                          model: {
                            value: _vm.form.destinationPort,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "destinationPort", $$v)
                            },
                            expression: "form.destinationPort"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          "label-width": "0",
                          title: _vm.$t("SeaExport.Remarks")
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.getItemTitle("Remark (max 300 letters)"))
                          )
                        ])
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "auto-width",
                        attrs: { "label-width": "0" }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            maxlength: 300,
                            disabled: !_vm.isEdit,
                            type: "textarea",
                            rows: 5
                          },
                          model: {
                            value: _vm.form.remarks,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "remarks", $$v)
                            },
                            expression: "form.remarks"
                          }
                        })
                      ],
                      1
                    ),
                    _c("el-form-item", { attrs: { "label-width": "0" } }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.getItemTitle("Description of Goods")))
                      ])
                    ]),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "auto-width",
                        attrs: { "label-width": "0" }
                      },
                      [
                        _c("cargo-rich-textarea", {
                          staticStyle: { height: "110px" },
                          attrs: {
                            disabled: !_vm.isEdit,
                            "text-chars": 0,
                            "warning-count": 512,
                            "is-trim": true,
                            "wrap-symbol": "r",
                            "auto-uppercase": "",
                            "auto-half-word": ""
                          },
                          model: {
                            value: _vm.form.cargoEnglishName,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "cargoEnglishName", $$v)
                            },
                            expression: "form.cargoEnglishName"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { title: "Cargo Type", label: "Cargo Type" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { clearable: false },
                            on: { change: _vm.changeCargoType },
                            model: {
                              value: _vm.form.docCargoType,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "docCargoType", $$v)
                              },
                              expression: "form.docCargoType"
                            }
                          },
                          [
                            _c("el-option", {
                              attrs: { value: "1", label: "1. General" }
                            }),
                            _c("el-option", {
                              attrs: { value: "2", label: "2. Dangerous" }
                            }),
                            _c("el-option", {
                              attrs: { value: "7", label: "7. Reefer Cargo" }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "UNDG Number", title: "UNDG Number" } },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.form.undgNumber,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "undgNumber", $$v)
                            },
                            expression: "form.undgNumber"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "IMO Class", title: "IMO Class" } },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.form.imoClass,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "imoClass", $$v)
                            },
                            expression: "form.imoClass"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "section form-column" },
              [
                _c(
                  "el-form",
                  {
                    staticStyle: { height: "100%" },
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "116px",
                      "label-position": "right"
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "title",
                        attrs: {
                          title: _vm.$t("SeaExport.TransportationInformation")
                        }
                      },
                      [_vm._v(_vm._s(_vm.getItemTitle("Shipping Information")))]
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.getItemTitle("MB/L NO"),
                          title: _vm.$t("SeaExport.MBLNumber")
                        }
                      },
                      [
                        _c("el-input", {
                          on: {
                            change: function($event) {
                              return _vm.$emit("syncThailandInfo", "mbl")
                            }
                          },
                          model: {
                            value: _vm.form.mbl,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "mbl", $$v)
                            },
                            expression: "form.mbl"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.getItemTitle("Vessel"),
                          title: _vm.$t("SeaExport.ShipName")
                        }
                      },
                      [
                        _c("el-input", {
                          on: {
                            change: function($event) {
                              return _vm.$emit("syncThailandInfo", "vessel")
                            }
                          },
                          model: {
                            value: _vm.form.vessel,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "vessel", $$v)
                            },
                            expression: "form.vessel"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.getItemTitle("Voyage"),
                          title: _vm.$t("SeaExport.Voyage")
                        }
                      },
                      [
                        _c("cargo-rich-textarea", {
                          staticStyle: { "min-height": "unset" },
                          attrs: {
                            disabled: _vm.readonly,
                            "text-chars": 0,
                            "warning-count": 10,
                            "is-trim": true
                          },
                          on: { change: _vm.changeVoyage },
                          model: {
                            value: _vm.form.voyageFlight,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "voyageFlight", $$v)
                            },
                            expression: "form.voyageFlight"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.getItemTitle("IMO"),
                          title: _vm.$t("SeaExport.ShipNumber")
                        }
                      },
                      [
                        _c("el-input", {
                          on: {
                            change: function($event) {
                              return _vm.$emit("syncThailandInfo", "vesselIMO")
                            }
                          },
                          model: {
                            value: _vm.form.vesselIMO,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "vesselIMO", $$v)
                            },
                            expression: "form.vesselIMO"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.getItemTitle("Call Sign"),
                          title: _vm.$t("SeaExport.BookingShipCallSign")
                        }
                      },
                      [
                        _c("el-input", {
                          on: {
                            change: function($event) {
                              return _vm.$emit("syncThailandInfo", "vesselCode")
                            }
                          },
                          model: {
                            value: _vm.form.vesselCode,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "vesselCode", $$v)
                            },
                            expression: "form.vesselCode"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.getItemTitle("ETD"),
                          title: _vm.$t("SeaExport.DateOfDeparture")
                        }
                      },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: { type: "date", "value-format": "yyyy-MM-dd" },
                          on: {
                            change: function($event) {
                              return _vm.$emit("syncThailandInfo", "etd")
                            }
                          },
                          model: {
                            value: _vm.form.etd,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "etd", $$v)
                            },
                            expression: "form.etd"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.getItemTitle("ETA"),
                          title: _vm.$t("SeaExport.ArrivalDate")
                        }
                      },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: { type: "date", "value-format": "yyyy-MM-dd" },
                          on: {
                            change: function($event) {
                              return _vm.$emit("syncThailandInfo", "eta")
                            }
                          },
                          model: {
                            value: _vm.form.eta,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "eta", $$v)
                            },
                            expression: "form.eta"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.getItemTitle("Place of Loading"),
                          title: _vm.$t("SeaExport.BillLadingPortOfDeparture")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            "select-type": _vm.TYPE_NAMES.basic_data_Seaport,
                            filterable: "",
                            "default-value": _vm.form.loadingPortCode || "",
                            "tag-name": "englishName"
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.portChange(
                                p,
                                "loadingPortCode",
                                "loadingPort"
                              )
                            }
                          }
                        }),
                        _c("el-input", {
                          attrs: { disabled: "" },
                          model: {
                            value: _vm.form.loadingPort,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "loadingPort", $$v)
                            },
                            expression: "form.loadingPort"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.getItemTitle("Place of Discharge"),
                          title: _vm.$t("SeaExport.BillLadingPortOfDischarge")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            "select-type": _vm.TYPE_NAMES.basic_data_Seaport,
                            filterable: "",
                            "default-value": _vm.form.dischargingPortCode || "",
                            "tag-name": "englishName"
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.portChange(
                                p,
                                "dischargingPortCode",
                                "dischargingPort"
                              )
                            }
                          }
                        }),
                        _c("el-input", {
                          attrs: { disabled: "" },
                          model: {
                            value: _vm.form.dischargingPort,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "dischargingPort", $$v)
                            },
                            expression: "form.dischargingPort"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "Berth Date", title: "Berth Date" } },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "datetime",
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                            format: "yyyy-MM-dd HH:mm"
                          },
                          on: {
                            change: function($event) {
                              return _vm.$emit("syncThailandInfo", "berthDate")
                            }
                          },
                          model: {
                            value: _vm.form.berthDate,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "berthDate", $$v)
                            },
                            expression: "form.berthDate"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "Shed Number/Release Port",
                          title: "Shed Number/Release Port"
                        }
                      },
                      [
                        _c("el-input", {
                          on: {
                            change: function($event) {
                              return _vm.$emit("syncThailandInfo", "shedNumber")
                            }
                          },
                          model: {
                            value: _vm.form.shedNumber,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "shedNumber", $$v)
                            },
                            expression: "form.shedNumber"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "section form-column" },
              [
                _c(
                  "el-form",
                  {
                    staticStyle: { height: "100%" },
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "100px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "title",
                        attrs: { title: _vm.$t("SeaExport.OtherInformation") }
                      },
                      [_vm._v(_vm._s(_vm.getItemTitle("Other")))]
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "auto-width",
                        attrs: { "label-width": "0" }
                      },
                      [
                        _c("cargo-ag-grid", {
                          staticStyle: { width: "100%", height: "200px" },
                          attrs: {
                            "grid-options": _vm.masterInfo.gridOptions,
                            "column-defs": _vm.masterInfo.columnDefs,
                            "row-data": [{ jobNo: _vm.job.jobNo }],
                            "show-side-bar": false
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "auto-width",
                        attrs: { "label-width": "0" }
                      },
                      [
                        _c("cargo-ag-grid", {
                          staticStyle: { width: "100%", height: "200px" },
                          attrs: {
                            "grid-options": _vm.thailand2.gridOptions,
                            "column-defs": _vm.thailand2ColumnDefs,
                            "row-data": _vm.thailand2.rowData
                          },
                          on: {
                            gridReady: function(params) {
                              _vm.thailand2.gridApi = params.api
                            }
                          }
                        }),
                        _c("div", { staticStyle: { padding: "5px 0" } }, [
                          _c(
                            "div",
                            { staticStyle: { float: "right" } },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    title: _vm.$t(
                                      "SeaExport.SynchronizeHBLInformation"
                                    )
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.$emit(
                                        "synchroThailandClickHandler"
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.getItemTitle("Synchronise HB/L"))
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "danger",
                                    title: _vm.$t("SeaExport.Delete")
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.$emit("removeCargoDoc")
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.getItemTitle("Delete")))]
                              )
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.getItemTitle("Carrier SCAC"),
                          title: _vm.$t("SeaExport.ShippingCompanySCAC")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { disabled: true, value: _vm.txtCarrierScAc }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "Ship Agent", title: "Ship Agent" } },
                      [
                        _c("cargo-company-select", {
                          attrs: {
                            "method-params": {
                              seaCmpAgent: true,
                              active: true
                            },
                            "default-value": _vm.form.shipAgent || ""
                          },
                          on: { change: _vm.changeShipAgent }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "Ship Agent Tax No.",
                          title: "Ship Agent Tax No."
                        }
                      },
                      [
                        _c("el-input", {
                          on: {
                            change: function($event) {
                              return _vm.$emit(
                                "syncThailandInfo",
                                "shipAgentTaxNo"
                              )
                            }
                          },
                          model: {
                            value: _vm.form.shipAgentTaxNo,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "shipAgentTaxNo", $$v)
                            },
                            expression: "form.shipAgentTaxNo"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          title: "Cargo Movement",
                          label: "Cargo Movement"
                        }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { clearable: false },
                            on: {
                              change: function($event) {
                                return _vm.$emit(
                                  "syncThailandInfo",
                                  "cargoMovement"
                                )
                              }
                            },
                            model: {
                              value: _vm.form.cargoMovement,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "cargoMovement", $$v)
                              },
                              expression: "form.cargoMovement"
                            }
                          },
                          [
                            _c("el-option", {
                              attrs: { value: "3", label: "3. Transhipment" }
                            }),
                            _c("el-option", {
                              attrs: { value: "4", label: "4. Over side" }
                            }),
                            _c("el-option", {
                              attrs: { value: "5", label: "5. Consolidate" }
                            }),
                            _c("el-option", {
                              attrs: { value: "6", label: "6. Through Cargo" }
                            }),
                            _c("el-option", {
                              attrs: { value: "7", label: "7. Transit" }
                            }),
                            _c("el-option", {
                              attrs: {
                                value: "L",
                                label: "L. Intransit to LAOS"
                              }
                            }),
                            _c("el-option", {
                              attrs: { value: "O", label: "O. OTHER" }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "section" }, [
        _c(
          "span",
          {
            staticClass: "title",
            attrs: { title: _vm.$t("SeaExport.ContainerInformation") }
          },
          [_vm._v(_vm._s(_vm.getItemTitle("House Container Information")))]
        ),
        _c(
          "div",
          { staticStyle: { display: "flex", "flex-direction": "column" } },
          [
            _c("cargo-ag-grid", {
              staticStyle: { width: "100%", height: "350px" },
              attrs: {
                "config-module": "130902",
                "grid-options": _vm.container.gridOptions,
                "column-defs": _vm.containerColumnDefs,
                "row-data": _vm.containerRowData
              },
              on: {
                gridReady: function(params) {
                  _vm.container.gridApi = params.api
                }
              }
            })
          ],
          1
        )
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-rich-textarea", {
            ref: "advanceTextDialogTextarea",
            staticStyle: { height: "198px" },
            attrs: {
              "text-chars": 0,
              "auto-uppercase": _vm.advanceTextDialog.isUppercase,
              "auto-half-word": _vm.advanceTextDialog.formatObj.autoHalfWord,
              "warning-count": 50,
              disabled: _vm.readonly
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEdit,
                      expression: "isEdit"
                    }
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }